<template>
  <BaseModal
    :show="show"
    height="92%"
    title="Schwere Krankheiten"
    @close="$emit('update:show', false)"
  >
    <div
      role="document"
      class="flex flex-col text-start gap-2"
    >
      <div
        v-for="{headline, content} in diseases"
        :key="headline"
      >
        <h4>
          {{ headline }}
        </h4>
        <p>
          {{ content }}
        </p>
      </div>
    </div>
  </BaseModal>
</template>

<script setup lang="ts">
import BaseModal from '@/application/components/BaseModal.vue';

defineProps<{ show: boolean }>();

defineEmits(['update:show']);

const diseases = [
  { headline: 'Herz-/Kreislaufsystem',
    content: 'Arteriosklerose, arterielle Verschlusskrankheit (AVK), Herzinfarkt/-fehler/-stillstand/-erkrankungen, '
        + 'Embolie, Durchblutungsstörungen, Kardiomyopathie, Thrombose, Bluthochdruck,  Koronare Herzkrankheit, '
        + 'Schlaganfall' },
  { headline: 'Blut',
    content: 'Anämie, Leukämie, Gerinnungsstörungen oder Bluterkrankheit' },
  { headline: 'Gehirn und zentrales Nervensystem',
    content: 'Alzheimer, Demenz, Epilepsie, Infantile Cerebralparese, Lähmungen, Parkinson, Multiple Sklerose, '
        + 'Polyneuropathie, Hirn- oder Hirnhautentzündung, Poliomyelitis, Schädel-Hirn-Verletzungen' },
  { headline: 'Innere Organe',
    content: 'Colitis ulcerosa, Hepatitis, erhöhte Leberwerte, innere Blutungen, Morbus Crohn, Nierenentzündung, '
        + 'Nierenversagen, Pankreatitis' },
  { headline: 'Psychische Erkrankungen und Verhaltensstörungen',
    content: 'Depressionen, Manien, Neurosen und psychosomatische Störungen, Psychosen, Schizophrenie oder '
        + 'Persönlichkeitsstörungen wie Borderline-Syndrom, Paranoia, Selbsttötungsversuch, Hirnorganisches '
        + 'Psychosyndrom, Autismus' },
  { headline: 'Funktionsbeeinträchtigung der Sinnesorgane',
    content: 'Blindheit, Taubheit, Schwerhörigkeit, Sehschwäche ab 7 Dioptrien, Glaukom, Katarakt, Netzhautablösung, '
        + 'Retinopathie, Uveitis' },
  { headline: 'Hormon-/Stoffwechselerkrankungen',
    content: 'Diabetes mellitus, Gicht' },
  { headline: 'Bewegungsapparat',
    content: 'Abnutzung, Amputation, Brüche/Risse, Verschleiß, Entzündungen, Fehlstellungen, Verletzungen, '
        + 'Verkrümmungen, Versteifungen, Vorfälle, Arthrose, Glasknochenkrankheit, Ischiasbeschwerden, Hexenschuss, '
        + 'Lumbago, Morbus Bechterew, Osteoporose, Osteopenie, Rheuma, Oberschenkelhalsbruch, Polyarthritis, '
        + 'Spina bifida, Knochenmarkentzündung/Osteomyelitis, immer wiederkehrende Verrenkungen '
        + '(habituelle Luxationen)' },
  { headline: 'Sonstige Gesundheitsstörungen oder -zustände',
    content: 'Transplantation, AIDS-/HIV-Infektion, Apnoe, Dialysepflichtigkeit, Bewusstlosigkeit, Schlafapnoe,'
        + ' Suchterkrankung (Alkohol, Drogen, Tabletten), Zirrhose, Krebs/Tumor, Tuberkulose, '
        + 'Hodgkin-Krankheit/Lymphogranulomatose, Down-Syndrom, Hydrozephalus/Wasserkopf' },
];

</script>
